module.exports = __webpack_public_path__ + "static/CONTACT-0580df92d6c12f57edc53871603ec981.png";